import { render } from "./LoyaltyCustomersManagement.html?vue&type=template&id=221d18a2&scoped=true"
import script from "./LoyaltyCustomersManagement.js?vue&type=script&lang=js"
export * from "./LoyaltyCustomersManagement.js?vue&type=script&lang=js"

import "./LoyaltyCustomersManagement.css?vue&type=style&index=0&id=221d18a2&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/Shiptech MyPlusRewards/mpr-web-admin-portal/src/MPR.MyPlusRewardsAdminPortal.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221d18a2"]])

export default __exports__